import callAPiBase from './base';

const lineLotApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineLotList',
      method: 'GET',
      useToken: true,
      title: 'Line Lot - List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineLotList',
      method: 'GET',
      useToken: true,
      title: 'Line Lot - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineLotCreate',
      method: 'POST',
      useToken: true,
      title: 'Line Lot - Create',
      data,
    }),
  addLines: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineLotAddLines',
      method: 'POST',
      useToken: true,
      title: 'Add Lines Lot - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineLotUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Line Lot - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/lineLotDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Line Lot - Delete',
      params,
    }),
};

export { lineLotApi };
export default lineLotApi;
